import type { Dayjs } from 'dayjs';
import React, { type FC, type ReactElement } from 'react';

import { useAuth } from '~/hooks/useAuth';

import dayjs from '~/dayjs';

const DateTime: FC<{
  value?: string | Dayjs;
}> = function ({ value }): ReactElement {
  const { user } = useAuth();

  const timezone = user?.timezone ?? 'America/Montreal';
  const format = user?.dateTimeFormat ?? 'LLL';

  if (!value) {
    return <span className='DateTime' />;
  }

  return <span className='DateTime'>{dayjs.utc(value).tz(timezone).format(format)}</span>;
};

export default DateTime;
